import { render, staticRenderFns } from "./IncidentWorkflowSummaryModal.vue?vue&type=template&id=306fbdb6&"
import script from "./IncidentWorkflowSummaryModal.vue?vue&type=script&lang=js&"
export * from "./IncidentWorkflowSummaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports